export default __webpack_public_path__ + "static/media/done.0af0e136.png";